<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<p class="ded"><span epub:type="pagebreak" id="page_v" title="v">For the late, great Jacques Debierue<br/>c. 1886–1970<br/><em>Memoria in aeterna</em><span epub:type="pagebreak" id="page_vi" title="vi"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?f5ba40f2